import React, { useState } from 'react';
const Card = ({ children }) => {
    return (
        <div className='rounded my-4 py-4 px-2' style={{ background: '#fff' }}>
            {children}
        </div>
    )
}
export default Card